import { render, staticRenderFns } from "./common_head.vue?vue&type=template&id=5c7c63c6&scoped=true"
import script from "./common_head.vue?vue&type=script&lang=js"
export * from "./common_head.vue?vue&type=script&lang=js"
import style0 from "./common_head.css?vue&type=style&index=0&id=5c7c63c6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c63c6",
  null
  
)

export default component.exports